export const testimonials = [
  {
    name: 'Linda M.',
    role: '58 — Columbus, Ohio · Crocheting for 25 years',
    initials: 'LM',
    topic: 'Modern Crochet Handbags',
    quote:
      "I'd saved a dozen photos of crescent bags but could never work out the shaping from a picture. The Crescent Crochet Bag in Volume 01 had the foundation chain, the stitch counts for every round and how to attach the strap. I finished it in one weekend and my daughter claimed it before I could even wear it. The baguette bag is next.",
  },
  {
    name: 'Rosa G.',
    role: '46 — San Antonio, Texas · Weekend crocheter',
    initials: 'RG',
    topic: 'Floral & Granny Square Bags',
    quote:
      "Granny squares are my happy place, but joining them into a bag that actually holds its shape always defeated me. The Daisy Granny Square Tote explains the color placement, the joining order and how to build the gusset. It came out looking like something from a boutique. I've already started the Sunflower bag in mustard and cream.",
  },
  {
    name: 'Karen D.',
    role: '62 — Nashville, Tennessee · Retired teacher',
    initials: 'KD',
    topic: 'Complete Pattern Instructions',
    quote:
      'What sold me is that these are real patterns, not just pretty pictures. The Classic Everyday Tote lists the yarn weight, how many skeins, the hook size and the finished measurements in inches and centimeters. The base is worked round by round with the count at the end of each round, so I always knew if I was on track.',
  },
  {
    name: 'Megan T.',
    role: '39 — Portland, Oregon · Mom of two',
    initials: 'MT',
    topic: 'Variety of Designs',
    quote:
      "I get bored making the same tote over and over. This bundle has everything: a raffia handbag for weddings, an oversized beach tote for summer, and a mini backpack my 9-year-old begged me to make. Fifty bags in completely different styles means I always have a new project ready when I finish one.",
  },
  {
    name: 'Barbara J.',
    role: '65 — Leeds, United Kingdom · Grandmother of five',
    initials: 'BJ',
    topic: 'Bonus Projects',
    quote:
      'I honestly bought it for the bags, but the bonus books have kept me busiest. I made strawberry and cherry keychains for all my grandchildren and a set of 3D roses to decorate a tote for my sister. They use up all my leftover yarn, and each little charm takes an evening at most.',
  },
]
